"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.changeSalesforceCredsButtonStyle = exports.changeSalesforceCredsTextStyle = exports.LoaderContainerStyle = exports.CardBreakStyle = exports.CardDescriptionStyle = exports.CardHeaderStyle = exports.CardContainerStyle = exports.CardListExpand = exports.CardListHeaderContentH3 = exports.CardListHeaderContentH1 = exports.CardListHeaderContent = exports.CardListHeaderIcon = exports.CardListBorder = exports.CardListContentIndent = exports.CardListContentHiddenStyle = exports.CardListContentStyle = exports.CardListHeader = exports.CardListStyle = exports.CardGeneralStyle = exports.CardBorderStyle = exports.predictiveModelEditorDeploySpinner = exports.ErrorContainer = exports.predictiveModelEditorDeploySelectProject = exports.predictiveModelEditorDeploySelectName = exports.predictiveModelEditorDeployButton = exports.predictiveModelEditorDeployModelCardContent = exports.predictiveModelEditorDeployModelCard = exports.predictiveModelEditorDeployModelSubspaceTitle = exports.predictiveModelEditorDeployModelCentered = exports.predictiveModelEditorNavItem = exports.predictiveModelEditorNavBorder = exports.predictiveModelEditorNav = exports.predictiveModelEditorModelResultContainer = exports.predictiveModelVersionStyle = exports.modelResultMetadataHeader = exports.predictiveModelAlertStyle = exports.predictiveModelAlertContainerStyle = exports.submitFeedbackFloatingFloatingActionButtonStyle = exports.predictiveModelEditorDeployBackground = exports.predictiveModelEditorRow = exports.predictiveModelEditorContainer = exports.predictiveModelEditorMain = void 0;
var prediction_model_results_viz_1 = require("@tableau/prediction-model-results-viz");
var widgets_1 = require("@tableau/widgets");
require("@tableau/fonts-tableau");
var StyleHelper_1 = require("./StyleHelper");
var deployBackgroundColor = '#165480';
// nav style variables
var navBackgroundColor = prediction_model_results_viz_1.VizColors.tableauGray03;
var navInnerBorderColor = prediction_model_results_viz_1.VizColors.tableauGray09;
var navWidth = '317px';
// deploy model
var deployModelCardContentPadding = 30;
var deployModelCardHeight = 425;
exports.predictiveModelEditorMain = (0, StyleHelper_1.cssClass)('editor-content-main', {
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 auto',
    width: '100%',
    height: '100%',
    overflow: 'auto',
    position: 'relative',
});
exports.predictiveModelEditorContainer = (0, StyleHelper_1.cssClass)('editor-subspace-container', {
    display: 'flex',
    flex: '1',
    overflowX: 'hidden',
    overflowY: 'auto',
});
exports.predictiveModelEditorRow = (0, StyleHelper_1.cssClass)('editor-container-main', {
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'row',
    flex: '1 1 auto',
    width: '100%',
    height: '100%',
});
exports.predictiveModelEditorDeployBackground = (0, StyleHelper_1.cssClass)('deploy-background', {
    backgroundColor: deployBackgroundColor,
    height: '-webkit-fill-available',
    width: '100%',
});
exports.submitFeedbackFloatingFloatingActionButtonStyle = (0, StyleHelper_1.cssClass)('submit-feedback-floating-action-button', {
    zIndex: 3,
    fontFamily: 'BentonSans SemiDemi',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '12px',
    lineHeight: '18px',
    letterSpacing: '0.2px',
    position: 'fixed',
    bottom: '20px',
    right: '40px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '8px 16px',
    gap: '4px',
    borderRadius: '25px',
    color: prediction_model_results_viz_1.VizColors.tableauGray13,
    fill: prediction_model_results_viz_1.VizColors.tableauGray13,
    boxShadow: '0px 4px 8px 4px rgba(0, 0, 0, 0.1)',
    border: '1px solid #FFFFFF',
    background: '#FFFFFF',
    $nest: {
        '&:hover': {
            border: '1px solid #D7ECF9',
            background: '#D7ECF9',
        },
        '&:active': {
            border: '1px solid #3498DB',
            background: '#3498DB',
        },
    },
});
exports.predictiveModelAlertContainerStyle = (0, StyleHelper_1.cssClass)('editor-alert-container', {
    zIndex: 2,
    position: 'absolute',
    width: '100%',
    height: '100%',
});
exports.predictiveModelAlertStyle = (0, StyleHelper_1.cssClass)('editor-alert', {
    width: '60%',
    margin: '0 auto',
    left: 0,
    right: 0,
});
exports.modelResultMetadataHeader = (0, StyleHelper_1.cssClass)('model-result-metadata-header', {
    fontSize: '16px',
    fontWeight: 400,
    fontStyle: 'normal',
    lineHeight: '16px',
    display: 'flex',
    color: prediction_model_results_viz_1.VizColors.tableauGray11,
    wordBreak: 'break-word',
    marginBottom: '12px',
});
exports.predictiveModelVersionStyle = (0, StyleHelper_1.cssClass)('model-version', {
    fontStyle: 'normal',
    fontWeight: 350,
    letterSpacing: '0.2px',
    color: prediction_model_results_viz_1.VizColors.tableauGray11,
    fontSize: '16px',
    lineHeight: '24px',
});
exports.predictiveModelEditorModelResultContainer = (0, StyleHelper_1.cssClass)('editor-model-result-container', {
    flexDirection: 'column',
});
exports.predictiveModelEditorNav = (0, StyleHelper_1.cssClass)('editor-nav-container', {
    flex: "0 0 ".concat(navWidth),
    width: "".concat(navWidth),
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'stretch',
    backgroundColor: navBackgroundColor,
    height: '100%',
    overflowY: 'auto',
});
exports.predictiveModelEditorNavBorder = (0, StyleHelper_1.cssClass)('nav-item-border', {
    borderTop: "1px solid ".concat(navInnerBorderColor),
});
exports.predictiveModelEditorNavItem = (0, StyleHelper_1.cssClass)('nav-item-section', {
    padding: '16px 32px',
});
exports.predictiveModelEditorDeployModelCentered = (0, StyleHelper_1.cssClass)('deploy-title', {
    display: 'flex',
    justifyContent: 'center',
});
exports.predictiveModelEditorDeployModelSubspaceTitle = (0, StyleHelper_1.cssClass)('deploy-title', {
    color: prediction_model_results_viz_1.VizColors.infoLight,
    width: '800px',
    marginTop: '35px',
});
exports.predictiveModelEditorDeployModelCard = (0, StyleHelper_1.cssClass)('deploy-card', {
    display: 'flex',
    justifyContent: 'center',
    width: '800px',
    backgroundColor: prediction_model_results_viz_1.VizColors.infoLight,
    height: "".concat(deployModelCardHeight, "px"),
});
exports.predictiveModelEditorDeployModelCardContent = (0, StyleHelper_1.cssClass)('deploy-content', {
    paddingLeft: "".concat(deployModelCardContentPadding, "px"),
    width: 'inherit',
    display: 'flex',
    flexDirection: 'column',
});
exports.predictiveModelEditorDeployButton = (0, StyleHelper_1.cssClass)('deploy-button', {
    marginTop: 'auto',
    marginBottom: '25px',
});
exports.predictiveModelEditorDeploySelectName = (0, StyleHelper_1.cssClass)('input-full-width', {
    flex: '1',
    width: '100%',
    marginBottom: '18px',
});
exports.predictiveModelEditorDeploySelectProject = (0, StyleHelper_1.cssClass)('project-selector', {
    position: 'relative',
    height: 250,
    width: '100%',
    padding: 1,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: widgets_1.TabStyles.Colors.L4,
    marginBottom: '10px',
});
// Error box
exports.ErrorContainer = (0, StyleHelper_1.cssClass)('error-container', {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
});
exports.predictiveModelEditorDeploySpinner = (0, StyleHelper_1.cssClass)('spinner', {
    textAlign: 'center',
});
// Card
exports.CardBorderStyle = (0, StyleHelper_1.cssClass)('card-border', {
    border: '1px solid ' + prediction_model_results_viz_1.VizColors.tableauGray05,
    borderRadius: '2px',
    boxSizing: 'border-box',
});
exports.CardGeneralStyle = (0, StyleHelper_1.cssClass)('card-general', {
    backgroundColor: prediction_model_results_viz_1.VizColors.white,
    margin: '0 16px 16px 0',
});
exports.CardListStyle = (0, StyleHelper_1.cssClass)('card-list', {
    display: 'flex',
    flexWrap: 'wrap',
});
exports.CardListHeader = (0, StyleHelper_1.cssClass)('card-list-header', {
    padding: '22px 16px',
    display: 'flex',
    width: '100%',
    alignItems: 'center',
});
exports.CardListContentStyle = (0, StyleHelper_1.cssClass)('card-list-content', {
    display: 'flex',
    flexWrap: 'wrap',
    marginLeft: '16px',
    maxHeight: '3000px',
    transition: 'max-height 0.3s ease-in',
    width: '100%',
});
exports.CardListContentHiddenStyle = (0, StyleHelper_1.cssClass)('card-list-content-hidden', {
    maxHeight: 0,
    transition: 'max-height 0.3s ease-out',
    overflow: 'hidden',
});
exports.CardListContentIndent = (0, StyleHelper_1.cssClass)('card-list-content-indent', {
    margin: '16px 0 0 91px',
});
exports.CardListBorder = (0, StyleHelper_1.cssClass)('card-list-border', {
    borderTop: '1px solid ' + prediction_model_results_viz_1.VizColors.tableauGray06,
});
exports.CardListHeaderIcon = (0, StyleHelper_1.cssClass)('card-list-header', {
    marginRight: '16px',
});
exports.CardListHeaderContent = (0, StyleHelper_1.cssClass)('card-list-header-content', {
    justifyContent: 'center',
    display: 'flex',
    flexDirection: 'column',
    fontWeight: 350,
    fontStyle: 'normal',
    lineHeight: '27px',
    letterSpacing: '0.2px',
});
exports.CardListHeaderContentH1 = (0, StyleHelper_1.cssClass)('card-list-header-content-h1', {
    fontSize: '18px',
});
exports.CardListHeaderContentH3 = (0, StyleHelper_1.cssClass)('card-list-header-content-h3', {
    fontSize: '14px',
});
exports.CardListExpand = (0, StyleHelper_1.cssClass)('card-list-expand', {
    marginLeft: 'auto',
    marginRight: '35px',
    display: 'flex',
    alignItems: 'center',
    width: '100px',
});
exports.CardContainerStyle = (0, StyleHelper_1.cssClass)('card-container', {});
exports.CardHeaderStyle = (0, StyleHelper_1.cssClass)('spinner', {
    height: '27px',
    fontWeight: 400,
    fontSize: '18px',
    lineHeight: '27px',
    letterSpacing: '0.2px',
    color: prediction_model_results_viz_1.VizColors.tableauGray11,
    padding: '12px',
});
exports.CardDescriptionStyle = (0, StyleHelper_1.cssClass)('card-header', {
    fontWeight: 700,
    height: '41px',
    color: prediction_model_results_viz_1.VizColors.tableauGray11,
    fontSize: '14px',
    lineHeight: '17px',
    letterSpacing: '0.2px',
    backgroundColor: prediction_model_results_viz_1.VizColors.infoLight,
    padding: '0 12px',
});
exports.CardBreakStyle = (0, StyleHelper_1.cssClass)('card-break', {
    flexBasis: '100%',
    height: 0,
});
// Loader
exports.LoaderContainerStyle = (0, StyleHelper_1.cssClass)('loader-container', {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    overflow: 'hidden',
});
exports.changeSalesforceCredsTextStyle = (0, StyleHelper_1.cssClass)('change-sf-user-text-link', {
    fontFamily: 'BentonSans Book',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '13px',
    color: '#1A699E',
    marginLeft: '-10px',
    marginTop: '10px',
});
exports.changeSalesforceCredsButtonStyle = (0, StyleHelper_1.cssClass)('change-sf-user-button', {
    fontFamily: 'BentonSans Book',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '13px',
    color: prediction_model_results_viz_1.VizColors.tableauGray10,
    marginTop: '20px',
});
//# sourceMappingURL=LayoutStyles.js.map